export const TabList = [
  {
    key: 'interviews',
    path: '/blog/interviews?page=1',
    text: '직무 인터뷰',
  },
  {
    key: 'stories',
    path: '/blog/stories?page=1',
    text: '비하인드 스토리',
  },
];
